import { GlobalController } from 'src/shared/global/GlobalController'
import Generator from './Generator'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'generator',
    component: Generator,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
